// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3sxBN","label":"Completed_label__1YWzD"};